import axios from "axios";
import { environment } from "../../../environments/environment";

export function getVendorDiscrepancies(companyId) {
    console.warn("fetching dicrepancies");
    return axios.post(`${environment.getVendorDiscrepancies}`, [
        {"columnName": "companyId", "value": companyId }
    ]);
}